<template>
    <main id="page">
        <section id="wrapper">
            <div class="container">
                <div class="row">
                    <!-- <div id="left-column" class="sidebar col-xs-12 col-sm-12 col-md-4 col-lg-3">
                        <div id="search_filters_wrapper" class="hidden-sm-down">
                            <div id="search_filter_controls" class="hidden-md-up">
                                <span id="_mobile_search_filters_clear_all"></span>
                                <button class="btn btn-secondary ok">
                                    <i class="material-icons rtl-no-flip">&#xE876;</i>
                                    OK
                                </button>
                            </div>
                            <div id="search_filters">
                                <p class="facet-top-title h6 hidden-sm-down">Filter By</p>
                                <Filters 
                                    v-for="(attribute, index) in attributes" 
                                    :key="index" 
                                    :attribute="attribute"
                                    @onFilterChange="handleFilterChange"
                                />
                            </div>
                        </div>
                    </div> -->
                    <!-- <div id="content-wrapper" class=" left-column col-xs-12 col-sm-12 col-md-8 col-lg-9"> -->
                    <div
                        id="content-wrapper"
                        class="left-column col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    >
                        <section id="main">
                            <section id="products">
                                <div>
                                    <div
                                        id="js-product-list-top"
                                        class="products-selection"
                                    >
                                        <div class="row">
                                            <div
                                                class="col-lg-6 col-md-3 hidden-sm-down total-products"
                                            >
                                                <p class="hidden-md-down">
                                                    There are
                                                    {{ items.length }} products.
                                                </p>
                                            </div>
                                            <div
                                                class="col-sm-12 hidden-md-up text-sm-center showing"
                                            >
                                                Showing 1-12 of 19 item(s)
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id class="hidden-sm-down">
                                    <section
                                        id="js-active-search-filters"
                                        class="hide"
                                    >
                                        <p class="h6 hidden-xs-up">
                                            Active filters
                                        </p>
                                    </section>
                                </div>
                                <GridSection
                                    :items="items"
                                    :isGrid="isGrid"
                                    :totalPages="totalPages"
                                    :size="size"
                                    :totalItems="totalItems"
                                    :loading="isLoading"
                                    @onUpdatePage="filter"
                                    :currentPage="
                                        paginationStore?.paginationData
                                            ?.current_page ?? 1
                                    "
                                    style="
                                        border-top: 1px solid transparent !important;
                                    "
                                />
                                <!-- {{ paginationStore.paginationData }} -->
                                <Paginator
                                    :meta="paginationStore.paginationData"
                                    @change:page="handlePageChange"
                                    @change:per-page="handlePerPageChange"
                                />
                            </section>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup>
import GridSection from "@/views/shop/GridSection.vue";
import { useProductStore } from "@/stores/product.store";
import Paginator from "@/components/shared/Paginator.vue";
import { usePaginationStore } from "@/stores/common/pagination.store";
import { useAttributeStore } from "@/stores/attribute.store";
import Filters from "@/views/shop/components/Filters.vue";
const productStore = useProductStore();
const paginationStore = usePaginationStore();
const attributeStore = useAttributeStore();
const route = useRoute(); // ✅

const isLoading = ref(false);
const activeFilters = ref({});
const isGrid = ref(true);
const selectedFilters = ref({});

const totalPages = computed(
    () => paginationStore.paginationData.total_pages || 1
);
const size = computed(() => paginationStore.paginationData.per_page || 20);
const totalItems = computed(() => paginationStore.paginationData.total || 0);
const items = computed(() => productStore.products ?? []);
const attributes = computed(() => attributeStore.attributes ?? []);

// const filter = async () => {
//     const filterParams = Object.entries(activeFilters.value).reduce((acc, [slug, values]) => {
//         if (values.length > 0) {
//             acc[`attribute_${slug}`] = values.join(',');
//         }
//         return acc;
//     }, {});

//     await fetchRecords({ ...filterParams });
// };

// const handleFilterChange = ({ slug, selected }) => {
//   if (!selected.length) {
//     delete activeFilters.value[slug];
//   } else {
//     activeFilters.value[slug] = selected.map(item => item.slug || item.name);
//   }
//   filter();
// };

const filter = async (extraParams = {}) => {
    const attributeFilters = Object.entries(activeFilters.value).reduce(
        (acc, [slug, values]) => {
            if (values.length > 0) {
                acc[`attribute_${slug}`] = values.join(",");
            }
            return acc;
        },
        {}
    );

    const finalParams = {
        ...attributeFilters,
        ...extraParams, // includes category, query, page, per_page etc.
    };

    await fetchRecords(finalParams);
};

const handleFilterChange = ({ slug, selected }) => {
    if (!selected.length) {
        delete activeFilters.value[slug];
    } else {
        activeFilters.value[slug] = selected.map(
            (item) => item.slug || item.name
        );
    }

    // Optional: you may want to reset the page to 1 when filter changes
    filter({ page: 1 });
};

const fetchRecords = async (payload = {}) => {
    isLoading.value = true;
    await Promise.all([productStore.fetchProducts(payload)]);
    isLoading.value = false;
};

const fetchAttributes = async (payload = {}) => {
    isLoading.value = true;
    await Promise.all([attributeStore.fetchAttributes(payload)]);
    isLoading.value = false;
};

const handlePageChange = async (page) => {
    fetchRecords({ page });
};

const handlePerPageChange = async (per_page) => {
    fetchRecords({ page: 1, per_page });
};
watch(
    () => route.query,
    (newQuery) => {
        const { query = "", category = "" } = newQuery;
        const payload = {
            ...(query ? { search: query } : {}),
            ...(category ? { category } : {}),
            page: 1
        };
        filter(payload);
    },
    { immediate: true, deep: true }
);

onMounted(async () => {
    activeFilters.value = {};
    const { query = "", category = "" } = route.query;

    const payload = {
        per_page: 20,
        ...(query ? { search: query } : {}), // ✅ fixed
        ...(category ? { category } : {}),
    };

    filter({
        per_page: 20,
        ...(query ? { search: query } : {}), // WooCommerce uses `search` instead of `query`
        ...(category ? { category } : {}),
    });
    await fetchAttributes();
    await fetchRecords(payload);
});

// onMounted(async() => {
//     activeFilters.value = {}
//     await fetchRecords({ per_page: 9 });
//     await fetchAttributes();
// });
</script>
